const LICENSES = ['Enterprise', 'Standard'];

const PRICING_OPTIONS: { [key: number]: Array<string> } = {
  0: ['Large Teams? Reach out to our sales team for custom prices.', 'All features includes'],
  1: [
    'Efficient Timesheet Management',
    'Dashboard Insights',
    'Simplified Payroll Processing',
    'Advanced Scheduling',
    'Easy Time Tracking',
    'Effortless Team Management',
    'Task-list Management',
    'Track assigned/unassigned orders',
    'Pos time clock',
    '24/7  live customer Support',
    'Unlimited locations support across all the features',
    'Commissions plan engine',
  ],
};

const PRICING_PLANS = [...Array(2)].map((_, index) => ({
  license: LICENSES[index],
  options: PRICING_OPTIONS[index],
  price: index === 1 ? '$3.99/month per user' : '',
}));

export {
  PRICING_PLANS,
};
